export const common = {
  // Navigation
  home: 'Home',
  fleet: 'Fleet',
  services: 'Services',
  about: 'About Us',
  contact: 'Contact',
  contacts: 'Contacts',
  
  // Buttons
  bookNow: 'Book Now',
  viewFleet: 'View Fleet',
  requestQuote: 'Request Quote',
  getQuote: 'Get Quote',
  submit: 'Submit',
  
  // Hero Section
  heroTitle: 'Book your stress-free airport transfer today and save up to 40%',
  heroSubtitle: 'Connecting you to Faro Airport with comfort and safety',
  heroMainTitle: 'Faro Airport Algarve Transfers',
  heroMainSubtitle: 'Licensed and Insured 24/7',
  heroServiceTitle: 'Fully Licensed and Insured Transfers • Available 24/7',
  heroServiceSubtitle: 'Premium service from Faro Airport to all Algarve with guaranteed fixed prices',
  heroBenefit1: 'Licensed',
  heroBenefit2: 'Insured',
  heroBenefit3: 'Fixed Prices',
  heroCtaBook: 'Book Now',
  heroCtaPricing: 'View Prices',
  heroTrust1: '4.9★ Rating',
  heroTrust2: '5000+ Clients',
  heroTrust3: 'Available 24/7',
  
  // Services Section - Main
  servicesTitle: 'Our Services',
  servicesSubtitle: 'We offer a complete range of transport services to make your stay in Algarve unforgettable',
  servicesMainTitle: 'Low Cost Transfer Services',
  servicesMainSubtitle: 'Reliable transfers from Faro Airport to all Algarve. Licensed, insured service available 24/7.',
  
  // Services - Individual Cards
  service1Title: 'Airport Transfers',
  service1Desc: 'Transfer service to/from Faro Airport with guaranteed punctuality and real-time flight monitoring.',
  service1Keywords: 'Faro Airport Transfer, Airport Taxi, Airport Transport',
  service1Feature1: 'Flight monitoring',
  service1Feature2: 'Driver waiting',
  service1Feature3: 'No waiting costs',
  
  service2Title: 'Private Transfers',
  service2Desc: 'Private and exclusive transport to any destination in Algarve. Comfort, privacy and total flexibility.',
  service2Keywords: 'Private Transfer Algarve, Private Transport, Exclusive Journey',
  service2Feature1: 'Local knowledge',
  service2Feature2: 'Optimized routes',
  service2Feature3: 'Flexible schedules',
  
  service3Title: 'Available 24/7',
  service3Desc: 'Service available 24 hours a day, 7 days a week. We are always ready to serve you, at any time.',
  service3Keywords: '24 Hour Transfer, 24/7 Service, Always Available',
  service3Feature1: 'Emergencies',
  service3Feature2: 'Late flights',
  service3Feature3: 'Total flexibility',
  
  service4Title: 'Licensed and Insured',
  service4Desc: 'All our vehicles and drivers are fully licensed and insured for your safety and peace of mind.',
  service4Keywords: 'Licensed Taxi Faro, Insured Transfer, Certified Service',
  service4Feature1: 'Certified drivers',
  service4Feature2: 'Inspected vehicles',
  service4Feature3: 'Comprehensive insurance',
  
  service5Title: 'Low Cost Prices',
  service5Desc: 'We offer the best market prices without compromising service quality. Special discounts for round trips.',
  service5Keywords: 'Cheap Transfer Algarve, Low Cost Price, Transfer Discount',
  
  service6Title: 'Professional Drivers',
  service6Desc: 'Experienced, licensed drivers with deep knowledge of Algarve. Excellence in service guaranteed.',
  service6Keywords: 'Professional Driver, Experienced Driver, Premium Service',
  
  // Why Choose FARWAYS
  whyChooseFarways: 'Why Choose FARWAYS?',
  whyReason1Title: 'Certified Low Cost Transfers',
  whyReason1Desc: 'All our taxis are licensed and comply with all passenger transport regulations in Portugal.',
  whyReason2Title: 'Full Insurance',
  whyReason2Desc: 'Total insurance coverage for passengers and luggage on all transfers from Faro Airport.',
  whyReason3Title: 'Transparent Prices',
  whyReason3Desc: 'No hidden costs. The price you see is the price you pay. Special discounts for round trips.',
  whyReason4Title: 'Easy Online Booking',
  whyReason4Desc: 'Book in 2 minutes. Immediate email confirmation. Free changes up to 24h before.',
  
  // Fleet
  fleetTitle: 'Our Fleet',
  fleetSubtitle: 'Modern and comfortable vehicles for all your transportation needs',
  ourFleet: 'Our Fleet',
  fleetDescription: 'Modern and comfortable vehicles for all your transportation needs',
  fleetPassengers: 'Passengers',
  luggage: 'Luggage',
  
  fleetEconomico: 'Economy',
  fleetEconomicoDesc: 'Ideal for individual trips or couples',
  fleetConforto: 'Comfort',
  fleetConfortoDesc: 'Perfect for small families',
  fleetSUV: 'SUV',
  fleetSUVDesc: 'Maximum comfort and style',
  fleetMPV: 'MPV',
  fleetMPVDesc: 'Extra space for luggage',
  fleetMinivan: 'Minivan',
  fleetMinivanDesc: 'Ideal for groups and large families',
  fleetMinibus: 'Minibus',
  fleetMinibusDesc: 'For large groups and events',
  
  fleetFeature1: 'Air Conditioning',
  fleetFeature2: 'Free Wi-Fi',
  fleetFeature3: 'Professional Driver',
  fleetFeature4: 'Leather Seats',
  fleetFeature5: 'Free Water',
  fleetFeature6: 'Premium Seats',
  fleetFeature7: 'Sound System',
  fleetFeature8: 'Extra Space',
  fleetFeature9: 'USB Port',
  fleetFeature10: 'Individual Seats',
  fleetFeature11: 'Entertainment',
  fleetFeature12: 'Premium Space',
  
  fleetExample1: 'Faro Airport » Vilamoura',
  fleetExample2: 'Faro Airport » Albufeira',
  fleetExample3: 'Faro Airport » Carvoeiro',
  fleetExample4: 'Faro Airport » Tavira',
  fleetExample5: 'Faro Airport » Portimão',
  fleetExample6: 'Faro Airport » Lagos',
  
  // About
  aboutTitle: 'About FARWAYS VIAGENS',
  aboutSubtitle: 'Excellence in Algarve transfers for over 10 years',
  aboutDesc1: 'We are a company specialized in transfers and tourist transport in Algarve, with over 15 years of experience in the sector. Our mission is to provide safe, comfortable and punctual trips to all our clients.',
  aboutDesc2: 'With a modern and diverse fleet, we serve Faro Airport and the entire Algarve region, offering personalized transport solutions for tourists, companies and special events.',
  
  aboutFeature1: 'Licensed and experienced drivers',
  aboutFeature2: 'Modern and well-maintained fleet',
  aboutFeature3: 'Competitive and transparent prices',
  aboutFeature4: 'Personalized 24/7 service',
  
  aboutStat1: '5000+',
  aboutStat1Label: 'Satisfied Customers',
  aboutStat2: '15+',
  aboutStat2Label: 'Years of Experience',
  aboutStat3: '50+',
  aboutStat3Label: 'Vehicles in Fleet',
  aboutStat4: '24/7',
  aboutStat4Label: 'Availability',
  
  yearsLabel: 'Years of Experience',
  
  // Contact
  contactTitle: 'Contacts',
  contactSubtitle: 'Get in touch with us for more information or bookings',
  phone: 'Phone',
  email: 'Email',
  address: 'Address',
  schedule: 'Schedule',
  scheduleText: '24 hours a day\n7 days a week',
  
  formTitle: 'Send us a Message',
  nameLabel: 'Name',
  namePlaceholder: 'Your name',
  emailPlaceholder: 'your.email@example.com',
  phoneLabel: 'Phone',
  phonePlaceholder: '+351 912 345 678',
  subjectLabel: 'Subject',
  subjectPlaceholder: 'Message subject',
  messageLabel: 'Message',
  messagePlaceholder: 'Your message...',
  submitButton: 'Send Message',
  successMessage: 'Message sent successfully!',
  errorMessage: 'Error sending message. Please try again.',
  
  // Footer
  footerDescription: 'Premium transfer services in the Algarve. We connect you to the best destinations with comfort and safety.',
  quickLinks: 'Quick Links',
  followUs: 'Follow Us',
  allRightsReserved: 'All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  
  // Booking Engine
  bookingTitle: 'Plan Your Journey With Us',
  bookingSubtitle: 'Simple, fast and hassle-free',
  from: 'From',
  to: 'To',
  date: 'Date',
  time: 'Time',
  passengers: 'Passengers',
  passengerSingular: 'Passenger',
  passengerPlural: 'Passengers',
  returnTrip: 'Return Trip',
  searchTransfers: 'Book',
  processing: 'Processing...',
  bookingConfirmed: 'Booking confirmed!',
  reservationNumber: 'Reservation number',
  pdfSentTo: 'PDF sent to',
  bookingError: 'Error creating booking. Please try again.',
  fullName: 'Full name',
  destination: 'Destination',
  
  // Child Seats
  childSeats: 'Child Seats',
  childSeat0to1: '0-1 years (€7)',
  childSeat1to3: '1-3 years (€6)',
  childSeat5to12: '5-12 years (€4)',
  childSeat0to1Short: '0-1 years',
  childSeat1to3Short: '1-3 years',
  childSeat5to12Short: '5-12 years',
  seat: 'seat',
  seats: 'seats',
  childSeatsIncluded: 'Child seats included',
  
  // Observations
  observations: 'Observations',
  observationsPlaceholder: 'E.g.: 2 golf clubs, extra luggage, etc.',
  
  // Privacy Policy
  privacyPolicyTitle: 'Privacy Policy',
  privacyLastUpdated: 'Last updated',
  privacyIntro: 'FARWAYS VIAGENS respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use and protect your personal information in accordance with the General Data Protection Regulation (GDPR).',
  acceptPrivacyPart1: 'I have read and accept the',
  acceptPrivacyPart2: '',
  mustAcceptPrivacy: 'You must accept the privacy policy to continue.',
  
  // Terms of Service
  termsTitle: 'Terms and Conditions of Service',
  termsLastUpdated: 'Last updated: January 2025',
  
  termsSection1Title: '1. Acceptance of Terms',
  termsSection1Text1: 'By using the FARWAYS website and our transfer services, you agree to these Terms and Conditions of Service. If you do not agree with any part of these terms, you should not use our services.',
  termsSection1Text2: 'We reserve the right to modify these terms at any time. Changes will take effect immediately upon posting on the website.',
  
  termsSection2Title: '2. Services Offered',
  termsSection2Text1: 'FARWAYS offers premium transfer services in the Algarve, including:',
  termsSection2Item1: 'Airport transfers to and from',
  termsSection2Item2: 'Transfers between cities and hotels',
  termsSection2Item3: 'Executive transportation services',
  termsSection2Item4: 'Customized tours',
  termsSection2Item5: 'Online booking system with automatic confirmation',
  
  termsSection3Title: '3. Bookings and Confirmations',
  termsSection3Text1: 'When making a booking through our online system:',
  termsSection3Item1: 'You will receive a unique booking number and a confirmation PDF by email',
  termsSection3Item2: 'The booking is considered confirmed after the confirmation email is sent',
  termsSection3Item3: 'You must present the booking number to the driver at the time of service',
  termsSection3Item4: 'You are responsible for providing correct and complete information (name, email, phone, locations and times)',
  
  termsSection4Title: '4. Cancellations and Changes',
  termsSection4Text1: 'Cancellation and change policy:',
  termsSection4Item1: 'Cancellations more than 24 hours in advance: full refund',
  termsSection4Item2: 'Cancellations between 12-24 hours: 50% refund',
  termsSection4Item3: 'Cancellations less than 12 hours: no refund',
  termsSection4Item4: 'Date/time changes must be requested at least 24 hours in advance',
  
  termsSection5Title: '5. Payment',
  termsSection5Text1: 'Payment can be made by credit/debit card or cash directly to the driver. Prices shown include all applicable taxes.',
  termsSection5Text2: 'We reserve the right to adjust prices without prior notice, but prices confirmed at the time of booking will be honored.',
  
  termsSection6Title: '6. Customer Responsibilities',
  termsSection6Text1: 'The customer agrees to:',
  termsSection6Item1: 'Be present at the pickup location at the scheduled time (we recommend 10 minutes early)',
  termsSection6Item2: 'Inform about extra luggage or special needs at the time of booking',
  termsSection6Item3: 'Behave respectfully towards the driver and keep the vehicle clean',
  
  termsSection7Title: '7. Limitation of Liability',
  termsSection7Text1: 'FARWAYS is not responsible for delays caused by traffic conditions, adverse weather conditions, or other factors beyond our control.',
  termsSection7Text2: 'We are not responsible for personal items left in vehicles, although we make every effort to return found items.',
  
  termsSection8Title: '8. Data Protection',
  termsSection8Text1: 'Your personal data is processed in accordance with our Privacy Policy and the General Data Protection Regulation (GDPR).',
  termsSection8Text2: 'Information provided during booking is stored securely in our system and used exclusively for service delivery.',
  
  termsSection9Title: '9. Applicable Law',
  termsSection9Text1: 'These terms are governed by Portuguese law. Any disputes will be resolved in the competent courts of Portugal.',
  
  termsSection10Title: '10. Contact',
  termsSection10Text1: 'For questions about these Terms and Conditions, contact us:',
  
  contactInfo: 'Contact Information',
  backToHome: 'Back to Home',
  
  // Legal Links
  complaintsBook: 'Complaints Book',
  arbitrationCenter: 'Arbitration Center',
  cookiePolicy: 'Cookie Policy',
  name: 'Name',
  
  // Pricing Page
  pricingTitle: 'Transfer Pricing',
  pricingSubtitle: 'Transparent and fixed prices for all Algarve routes',
  pricingDescription: 'Check our competitive prices for transfers from Faro Airport to the main destinations in the Algarve and Spain.',
  searchRoute: 'Search route by destination...',
  noRoutesFound: 'No routes found',
  routeFound: 'route found',
  routesFound: 'routes found',
  tryDifferentSearch: 'Try searching for another destination or clear the search to see all routes.',
  clearSearch: 'Clear Search',
  route: 'Route',
  economico: 'Economy',
  conforto: 'Comfort',
  suv: 'SUV',
  mpv: 'MPV',
  minivan: 'Minivan',
  minibus: 'Minibus',
  luxo: 'Luxury',
  bookThisRoute: 'Book This Route',
  pricesIncludeVAT: 'All prices include VAT',
  noHiddenFees: 'No hidden fees',
  fixedPrices: 'Fixed prices guaranteed',
  allVehiclesInclude: 'All vehicles include',
  professionalDriver: 'Professional driver',
  freeWifi: 'Free Wi-Fi',
  airConditioning: 'Air conditioning',
  freeWater: 'Free water',
  flightMonitoring: 'Flight monitoring',
  meetAndGreet: 'Meet & greet service',
  pricing: 'Pricing',
  vehicleType: 'Vehicle Type',
  totalValue: 'Total Value',
  discountApplied: '10% discount applied (round trip)',
  action: 'Action',
  importantInfo: 'Important Information',
  oneWayPrices: 'Prices valid for one-way trips',
  roundTripDiscount: 'Round trips: 10% discount',
  pricesIncludeTax: 'All prices include VAT at legal rate',
  noWaitingCosts: 'No waiting costs at airport',
  
  // Winter Discount
  winterDiscount: '❄️ Winter Discount - 30% OFF',
  winterDiscountDescription: 'Valid from November to March + 10% extra on round trips',
  winterDiscountActive: '30% winter discount already applied to displayed prices',
  winterDiscountApplied: '30% winter discount applied',
  
  // Booking Engine Additional
  routeNotInTable: 'Route not found in price table',
  contactForQuote: 'Contact us for a personalized quote for this route.',
  
  // 404 Page
  notFoundTitle: 'Page Not Found',
  notFoundSubtitle: 'It seems this route doesn\'t exist on our map',
  notFoundDescription: 'The page you are looking for may have been moved or doesn\'t exist. But don\'t worry, we can take you back to the right destination!',
  goHome: 'Go Home',
  viewPricing: 'View Pricing',
  contactUs: 'Contact Us',
  error404: 'Error 404',
  
  // Contact Page Additional
  contactInformation: 'Contact Information',
  howToGetHere: 'How to Get Here',
  findUsEasily: 'Find us easily in the center of Faro',
  sendUsMessage: 'Send us a Message',
  fillFormBelow: 'Fill out the form below and we will contact you shortly.',
  maxCharacters: 'Maximum 500 characters',
  onlineComplaintsBook: 'Online Complaints Book',
  algarveArbitrationCenter: 'Algarve Consumer Arbitration Center',
  
  // Testimonials
  testimonialsTitle: 'What Our Clients Say',
  testimonialsSubtitle: 'Over 5000 satisfied customers trust our transfer services',
  testimonial1: 'Impeccable service! The driver was waiting for me at the airport with a sign with my name. The car was luxurious and very comfortable. I highly recommend it for those looking for quality and punctuality.',
  testimonial2: 'I have used FARWAYS services several times for business trips. Always punctual, professional and with vehicles in excellent condition. It is my first choice for transfers in the Algarve.',
  testimonial3: 'We took a family trip and booked a minivan. More than enough space for all of us and the luggage. The driver was very friendly and gave us great tips about the region. Fantastic experience!',
  testimonial4: 'Excellent value for money. The service exceeded my expectations. Very polite driver who knows the region well. I will definitely use it again.',
  testimonial5: 'First class service! I booked a transfer from the airport to the hotel and everything was perfect. The vehicle was new and very clean. I felt very safe throughout the trip.',
  testimonial6: 'I use it regularly for business trips. The punctuality is impressive and the drivers are always very professional. The best transfer service I have ever experienced in Portugal.',
  testimonialDate1: 'March 2024',
  testimonialDate2: 'February 2024',
  testimonialDate3: 'January 2024',
  testimonialDate4: 'December 2023',
  testimonialDate5: 'November 2023',
  testimonialDate6: 'October 2023',
  averageRating: 'Average Rating',
  happyClients: 'Happy Clients',
  verified: 'Verified',
  awards: 'Awards',
  
  // FAQ Page
  faqTitle: 'Frequently Asked Questions',
  faqSubtitle: 'Find quick answers to the most common questions about our transfer services in the Algarve',
  
  // FAQ Categories
  faqCategoryAll: 'All',
  faqCategoryReservas: 'Bookings & Changes',
  faqCategoryAeroporto: 'Airport & Meeting',
  faqCategoryBagagem: 'Luggage & Extras',
  faqCategoryServico: 'Service Types',
  faqCategoryPagamento: 'Payment & Prices',
  faqCategorySeguranca: 'Safety & Trust',
  
  // FAQ Questions and Answers - Reservas
  faqQuestion1: 'Can I make changes to my booking?',
  faqAnswer1: 'Yes, you can change your booking up to 24 hours before the scheduled pickup time. To make changes, access the "My Booking" section on our website using the details from your confirmation email. If you cannot access online, contact us through the contact form or call +351 937 545 000.',
  
  faqQuestion2: 'How can I cancel my booking?',
  faqAnswer2: 'You can cancel through the "My Booking" section on our website, using the details from your confirmation email. Cancellation policy:\n\n• More than 24h in advance: full refund\n• Between 12-24h: 50% refund\n• Less than 12h: no refund\n\nIf you cannot access online, contact us directly.',
  
  faqQuestion3: 'What if my flight is delayed or cancelled?',
  faqAnswer3: 'Don\'t worry! We monitor all flights automatically. If your flight is delayed, your driver will be informed and will adjust the pickup time. There are no additional costs for flight delays. Updates are subject to driver availability.',
  
  faqQuestion4: 'My flight details have changed, do I need to inform you?',
  faqAnswer4: 'Yes, please send the new flight schedule as soon as possible through the "My Booking" section or contact us directly. If boarding is in less than 24 hours, urgently call +351 937 545 000 to ensure the driver is informed.',
  
  // FAQ Questions and Answers - Aeroporto
  faqQuestion5: 'What is the meeting point at the airport?',
  faqAnswer5: 'The driver will be waiting for you in the arrivals hall of Faro Airport, holding a sign with your name. The exact location will be confirmed in the booking confirmation email. If you cannot find the driver, call the emergency number provided in the email.',
  
  faqQuestion6: 'How long does the driver wait at the airport?',
  faqAnswer6: 'The driver waits up to 60 minutes after the scheduled landing time at no additional cost. This time is sufficient to collect luggage and pass through customs. If you need more time, contact us in advance.',
  
  faqQuestion7: 'How do I identify the driver?',
  faqAnswer7: 'The driver will have a sign with your full name (as indicated in the booking) and FARWAYS uniform. All our drivers are licensed professionals and identified. If in doubt, you can always call the emergency number provided in the confirmation email.',
  
  // FAQ Questions and Answers - Bagagem
  faqQuestion8: 'What is the size of a medium and small suitcase?',
  faqAnswer8: 'Medium suitcase: approximately 65-70 cm (26-27 inches) - standard checked luggage\nSmall suitcase: about 35 cm (14 inches) - backpack or hand luggage\n\nIf you have large, special luggage (golf clubs, bicycles, etc.) or more than standard quantity, indicate in the "Observations" field when booking to ensure the appropriate vehicle.',
  
  faqQuestion9: 'Do you provide child seats?',
  faqAnswer9: 'Yes! We provide child and baby seats upon request:\n\n• 0-1 years (Group 0+): €7\n• 1-3 years (Group 1): €6\n• 5-12 years (Group 2/3): €4\n\nYou can request in the "Child Seats" section during booking. The seats comply with all European safety standards.',
  
  faqQuestion10: 'Can I bring extra luggage?',
  faqAnswer10: 'Yes, but it is important to inform us in the booking. Each vehicle type has specific luggage capacity. If you have more luggage than standard, we can suggest a larger vehicle or arrange additional transport. Always indicate in the "Observations" field special items such as sports equipment, baby strollers, etc.',
  
  // FAQ Questions and Answers - Serviço
  faqQuestion11: 'Will I share the vehicle with other passengers?',
  faqAnswer11: 'No! All our services are PRIVATE transfers. You and your group will be the only occupants of the vehicle. We do not do shared transfers. The vehicle is exclusively yours throughout the journey, ensuring comfort, privacy and punctuality.',
  
  faqQuestion12: 'What is included in the transfer service?',
  faqAnswer12: 'Our service includes:\n\n✅ Licensed professional driver\n✅ Clean and comfortable vehicle\n✅ Air conditioning\n✅ Free Wi-Fi\n✅ Free water\n✅ Flight monitoring\n✅ Meet & greet service at the airport\n✅ Luggage assistance\n✅ No waiting costs (up to 60 min at airport)\n✅ All taxes included',
  
  faqQuestion13: 'Does the service take me directly to the hotel?',
  faqAnswer13: 'Yes! Our private transfer service takes you directly from the airport to the door of your hotel, apartment or any other address in the Algarve. No intermediate stops, no waiting. Door-to-door service with maximum comfort and speed.',
  
  // FAQ Questions and Answers - Pagamento
  faqQuestion14: 'What payment methods are accepted?',
  faqAnswer14: 'We accept:\n\n💳 Credit/debit card (Visa, Mastercard, American Express)\n💰 Cash (Euros) directly to the driver\n🌐 PayPal (online payment)\n💼 Bank transfer (for corporate bookings)\n\nOnline payment is secure and processed through a certified platform.',
  
  faqQuestion15: 'Do prices include all fees?',
  faqAnswer15: 'Yes! The prices shown on our website are FINAL and include:\n\n✅ VAT at legal rate\n✅ All fees and taxes\n✅ Fuel\n✅ Tolls (if applicable)\n✅ Full insurance\n✅ No hidden costs\n\nThe price you see is the price you pay. Guaranteed!',
  
  faqQuestion16: 'Is there a discount for round trips?',
  faqAnswer16: 'Yes! We offer an automatic 10% discount on all round trip bookings. In addition, we have a special winter promotion (November to March) with 30% discount + 10% additional on round trips. Discounts are applied automatically at the time of booking.',
  
  // FAQ Questions and Answers - Segurança
  faqQuestion17: 'Are the drivers licensed?',
  faqAnswer17: 'Yes! All our drivers are:\n\n✅ Professionally licensed (TVDE/Taxi)\n✅ With minimum 5 years experience\n✅ Certified by transport authority\n✅ With deep knowledge of the Algarve\n✅ Fluent in Portuguese, English and Spanish\n✅ Trained in customer service\n✅ With clean criminal record',
  
  faqQuestion18: 'Are the vehicles insured?',
  faqAnswer18: 'Yes! All our vehicles have:\n\n✅ Comprehensive insurance\n✅ Passenger insurance\n✅ Up-to-date technical inspections\n✅ Regular maintenance\n✅ Cleaning and disinfection after each service\n✅ Complete safety equipment\n\nYour safety is our top priority.',
  
  faqQuestion19: 'How can I be sure the booking is legitimate?',
  faqAnswer19: 'FARWAYS is a registered and licensed company:\n\n📋 NIPC: 505413850\n📋 RNAVT: 8586 (National Registry of Travel Agents)\n📋 Valid transport license\n📋 Over 15 years of experience\n📋 +5000 satisfied customers\n📋 Verified reviews\n\nYou will receive an immediate confirmation email with all details and booking number. You can always verify legitimacy by contacting us directly.',
  
  // FAQ Additional
  faqNoResults: 'No questions found in this category',
  faqStillHaveQuestions: 'Still have questions?',
  faqContactText: 'Our team is available 24/7 to help',
  faqContactButton: 'Contact Us',
};
